import { render, staticRenderFns } from "./HWP_Family.vue?vue&type=template&id=3083d988&scoped=true&"
import script from "./HWP_Family.vue?vue&type=script&lang=js&"
export * from "./HWP_Family.vue?vue&type=script&lang=js&"
import style0 from "./HWP_Family.vue?vue&type=style&index=0&id=3083d988&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3083d988",
  null
  
)

export default component.exports